import { QueryItem } from '../../Tonnage/models/TonnageQueryModel';
import { RootState } from '../../../app/store';
import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit"
import { OrderDirection } from '../../Datatable/OrderDirection';
import ContactNameModel from '../../ContactSelector/models/ContactNameModel';
import MyFixtureQueryModel, { HasEnumValue } from '../models/MyFixtureQueryModel';
import { } from '../../Tonnage/models/TonnageQueryModel';
import CompanyNamePICModel from '../../CompanyNamePIC/models/CompanyNamePICModel';
import FixtureModel from '../../FixtureManagement/models/FixtureModel';

interface MyFixtureSearchState {
    query: MyFixtureQueryModel,
    searchResults: FixtureModel[],
    companyNamePICSearchKeyword: string,
    companyNamePICData: CompanyNamePICModel[],
    contactAccountNames: ContactNameModel[],
    triggerSearch: number,
    datatableSelectedIndex: number,
    searchResultTotalRecord: number,
    checkedMyFixtures: FixtureModel[],
    triggerFocusVesselName: number,
}

const initialState: MyFixtureSearchState = {
    query: {
        year: 0,
        vesselNames: [],
        brokers: [],
        support: 0,
        statuses: [],
        bizTypes: [],
        bankAccounts: [],
        hasInvNo: HasEnumValue.All.toString(),
        receivedDateYear: -2,
        hasEvaluation: HasEnumValue.All.toString(),
        showCloseFile: false,
        orderBy: "updatedDate",
        orderDirection: OrderDirection.Desc,
    } as MyFixtureQueryModel,
    searchResults: [],
    companyNamePICSearchKeyword: "",
    companyNamePICData: [],
    contactAccountNames: [],
    triggerSearch: 0,
    datatableSelectedIndex: -1,
    searchResultTotalRecord: 0,
    checkedMyFixtures: [],
    triggerFocusVesselName: 0,
}

export const MyFixtureSearchSlice = createSlice({
    name: "MyFixtureSearch",
    initialState,
    reducers: {
        setMyFixtureSearchResults: (state, action: PayloadAction<FixtureModel[]>) => {
            state.searchResults = action.payload;
        },
        setMyFixtureCompanyNamePICSearchKeyword: (state, action: PayloadAction<string>) => {
            state.companyNamePICSearchKeyword = action.payload;
        },
        setTriggerMyFixtureSearch: (state, action: PayloadAction<number>) => {
            state.triggerSearch = action.payload;
        },
        setDatatableSelectedMyFixtureIndex: (state, action: PayloadAction<number>) => {
            state.datatableSelectedIndex = action.payload;
        },
        setSearchResultTotalRecord: (state, action: PayloadAction<number>) => {
            state.searchResultTotalRecord = action.payload;
        },
        setYear: (state, action: PayloadAction<number>) => {
            state.query.year = action.payload;
        },
        setVesselNames: (state, action: PayloadAction<QueryItem[]>) => {
            state.query.vesselNames = action.payload;
        },
        setBrokers: (state, action: PayloadAction<QueryItem[]>) => {
            state.query.brokers = action.payload;
        },
        setBizTypes: (state, action: PayloadAction<QueryItem[]>) => {
            state.query.bizTypes = action.payload;
        },
        setSupport: (state, action: PayloadAction<number>) => {
            state.query.support = action.payload;
        },
        setStatuses: (state, action: PayloadAction<QueryItem[]>) => {
            state.query.statuses = action.payload;
        },
        setOrderBy: (state, action: PayloadAction<string>) => {
            state.query.orderBy = action.payload;
        },
        setOrderDirection: (state, action: PayloadAction<OrderDirection>) => {
            state.query.orderDirection = action.payload;
        },
        setMyFixtureQuery: (state, action: PayloadAction<MyFixtureQueryModel>) => {
            state.query = action.payload;
        },
        setHasInvNo: (state, action: PayloadAction<string>) => {
            state.query.hasInvNo = action.payload;
        },
        setShowCloseFile: (state, action: PayloadAction<boolean>) => {
            state.query.showCloseFile = action.payload;
        },
        setReceivedDateYear: (state, action: PayloadAction<number>) => {
            state.query.receivedDateYear = action.payload;
        },
        setHasEvaluation: (state, action: PayloadAction<string>) => {
            state.query.hasEvaluation = action.payload;
        },
        resetMyFixtureSearch: (state) => {
            state.query = initialState.query;
        },
        setCompanyNamePICData: (state, action: PayloadAction<CompanyNamePICModel[]>) => {
            state.companyNamePICData = action.payload;
        },
        setContactAccountNames: (state, action: PayloadAction<ContactNameModel[]>) => {
            state.contactAccountNames = action.payload;
        },
        setCheckedMyFixtures: (state, action: PayloadAction<FixtureModel[]>) => {
            state.checkedMyFixtures = action.payload;
        },
        setTriggerFocusVesselName: (state, action: PayloadAction<number>) => {
            state.triggerFocusVesselName = action.payload;
        },
    }
});

export const MyFixtureSearchSelector = createSelector(
    (state: RootState) => state.myFixtureSearch,
    (data) => data
);

export const {
    setMyFixtureSearchResults,
    setMyFixtureCompanyNamePICSearchKeyword,
    setTriggerMyFixtureSearch,
    setDatatableSelectedMyFixtureIndex,
    setSearchResultTotalRecord,
    resetMyFixtureSearch,
    setCompanyNamePICData,
    setCheckedMyFixtures,
    setTriggerFocusVesselName,
    setMyFixtureQuery,
    setYear,
    setVesselNames,
    setBrokers,
    setHasInvNo,
    setReceivedDateYear,
    setHasEvaluation,
    setBizTypes,
    setSupport,
    setStatuses,
    setShowCloseFile,
    setOrderBy,
    setOrderDirection,
} = MyFixtureSearchSlice.actions;

export default MyFixtureSearchSlice.reducer;